import React from 'react';
import {AppHelmet, AppWrapper, baseUrl, baseRealtyUrl, baseRealEstateUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import {
  GlobalIcons,
  ImageCapCenterHQ,
  ImageSmores2,
  ImageSmores,
  ImageGlenAllenVA,
  ImageGlenAllenVA2,
  ImageGlenAllenVAPieDay,
  ImageGlenAllenVAPieDay2,
  ImageGlenAllenVAPieDay3,
  ImageGlenAllenVAPieDay4,
  ImageGlenAllenVAHalloweenTeam,
  ImageGlenAllenVAHalloween,
  ImageRichmondRaceway
} from '@capcenter/shared-legacy';
import {ImageGlenAllenOffice} from '@capcenter/shared-service-map';
import './Locations.scss';
import getElasticSearchListings from '../Utilities/GetElasticSearchListings';
import buildListingURL from '../Utilities/BuildURLString';


GlobalIcons();

function VAGlenAllen(
  props: any
) {
  const [renderedHtmlListings, setRenderedHtmlListings] = React.useState<Array<any>>([]);
  const [initialized, setInitialized] = React.useState<boolean>(false);
  let htmlListings: any = [];

  async function getListings(city: string, county: string, state: string) {
    const response = await getElasticSearchListings({isRealty: props.custom.isRealty, city: city, county: county, state: state});
    return response.json();
  };

  function buildListingLinkText(listingSource: any) {
    const addressLineOne = listingSource?.UnparsedAddress?.replace(/#/g, 'Unit ');
    const city = listingSource?.City;
    const stateOrProvince = listingSource?.StateOrProvince;
    const postalCode = listingSource?.PostalCode;

    let propertyAddress = `${addressLineOne}, ${city}, ${stateOrProvince} ${postalCode}`;

    if (listingSource?.isCapcenterListing) {
      propertyAddress += " (CapCenter Listing)";
    }

    return propertyAddress;
  }

  async function renderListings() {
    const listingResponse = await getListings(props.custom.city, props.custom.county, props.custom.state);
    const listings = listingResponse.hits.hits;

    for (let i = 0; i < listings.length; i++) {

      let listItem =
        <li key={i}>
          <a href={getUrlWithUtmQueryString(buildListingURL(listings[i]._source))} target='_blank' rel='noreferrer noopener'>
            {buildListingLinkText(listings[i]._source)}
          </a>
        </li>;

      htmlListings.push(listItem);
    }

    setRenderedHtmlListings(htmlListings);
  }

  if (!initialized) {
    setInitialized(true);
    renderListings();
  }

  return (
    <React.Fragment>
      {(
        <AppWrapper>
          <>
            <AppHelmet
              custom={props.custom}
            />

            <div role="document">
              <main className={"locations container pb-4 " + (props.custom.code)} role="main">
                <article>
                  <header>
                    <div className={(props.custom.code)}>
                      <div className={"col-12" + (props.custom.code)}>
                        <h1>{props.custom.title}</h1>
                        <p>{props.custom.description}</p>
                      </div>
                    </div>
                  </header>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <h3>Address</h3>
                        <p>
                          <a href="https://goo.gl/maps/yD6wUNqCnUP75RYj8" title="CapCenter HQ in Glen Allen, VA" target="_blank" rel="noreferrer noopener">
                            4461 Cox Road
                            <br />
                            Glen Allen, VA 23060
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Contact</h3>
                        <p>
                          <a href="tel:8049685000">
                            +1 (804) 968-5000
                          </a>
                          <br />
                          <a href="mailto:customerservice@capcenter.com">
                            customerservice@capcenter.com
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Hours</h3>
                        <p>
                          Monday - Friday, 8:30 AM - 5 PM
                          <br />
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className="mb-4">
                    <p>
                      {props.custom.isRealty ?
                        (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm p-4'}>Find our best REALTORS® near {props.custom.city}, {props.custom.state}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm p-4'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.city}, {props.custom.state}</a></p></>) : ""}
                      {props.custom.isMortgage ?
                        (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm p-4'}>Apply now for a mortgage near {props.custom.city}, {props.custom.state}</a>) : ""}
                    </p>

                    <p>
                      <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/virginia/glen-allen/purchase/all`)} className={'d-flex btn-primary btn-sm p-4'}>View our best mortgage interest rates for today near {props.custom.city}, {props.custom.state}</a>
                    </p>

                    <p>
                      <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm p-4'}>Get a free, anonymous mortgage quote calculated to compare mortgage rates and closing costs in {props.custom.city}, {props.custom.state}</a>
                    </p>
                  </section>


                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h2>About CapCenter {props.custom.isRealty ? "Realty" : "Mortgage"} in {props.custom.city}, {props.custom.state}</h2>
                      </div>

                      <div className="col-12 col-md-8">
                        <p>
                          Glen Allen, VA is a suburb of the Richmond metropolitan area with a population of 14,842 in 2020. Glen Allen is in <a href="https://www.capcenterhomes.com/homes/location/county/henrico-va">Henrico County</a> and is one of the best places to live in Virginia.
                          CapCenter is proud to be headquartered in Innsbrook of Glen Allen, VA where many employees live, work, and enjoy. We host many activities for our employees and our clients on our Innsbrook campus.
                        </p>

                        <p>
                          Glen Allen, VA is one of the best places to live and work because of its proximity to shops, restaurants, parks, and businesses. Our Glen Allen, VA office supports
                          Henrico County and its surrounding areas in the Greater Richmond Region such as
                          Richmond City (RVA), Church Hill, The Fan, Jackson Ward, Monroe Ward, Downtown, Shockoe Slip, Shockoe Bottom, Museum District,
                          Carytown, Bon Air, Midlothian, Manchester, Chester, Chesterfield, Mechanicsville, Tuckahoe, Lorraine, Manakin, Manakin Sabot, Powatan, Goochland, Ashland, Southside, Northside, Lakeside,
                          Brandermill, Woodlake, Moseley, Malvern Gardens, Three Chopt, Willow Lawn, Highland Park, Highland Springs, Sandston, Montrose, Varina, Forest Hill, Stony Point, Wyndham, Windsor Farms, Mooreland Farms,
                          and more.
                        </p>

                        <p>
                          &nbsp;See homes in <a href={`${baseRealEstateUrl}/homes/location/city/glen-allen-va`} target="_blank" rel="noreferrer noopener">Glen Allen, VA</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/glen-allen-va`} target="_blank" rel="noreferrer noopener">Innsbrook, VA</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/county/henrico-va`} target="_blank" rel="noreferrer noopener">Henrico county, VA</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/glen-allen-va`} target="_blank" rel="noreferrer noopener">Wyndham, VA</a>.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            ("Our top-rated REALTORS®, real estate agents, and brokers in " + props.custom.city + ", " + props.custom.state + " are real estate experts known to work hard to help you buy and sell homes quickly for a great price.") : ""}
                          {props.custom.isMortgage ?
                            ("Our mortgage professionals (licensed loan officers and home loan consultants) in " + props.custom.city + ", " + props.custom.state + " are mortgage experts trained to guide you through the complicated loan underwriting process so you can close on time with Zero hassles. CapCenter offers conventional, HomeReady®, Home Possible, Jumbo, VA, FHA, and adjustable rate mortgage loan products.") : ""}
                        </p>

                        <p>
                          CapCenter specializes in no-fee and low-fee mortgages with low interest rates.
                          We may initially seem like we don't offer the best rates in the market, but many lenders charge additional fees for lower interest rates in the form of points and lender and non-lender closing costs. If you're looking for the lowest rate, try applying expected closing costs to pay down discount points with CapCenter. In an apples to apples comparison, <strong>we offer some of the best rates in the market and do not simply add closing costs into the loan balance</strong>. We are always striving to offer the best overall package for each of our clients' unique needs.
                          We encourage borrowers to not only look at interest rates and APR but also non-lender fees and terms when comparing loan estimates.
                          CapCenter helps borrowers get around closing costs by eliminating fees for borrowers for many popular home loan products.
                          Many of our most popular home loan products have <strong>no closing costs</strong> or <strong>zero closing costs</strong> mortgages, which are often the best mortgage options for <strong>first-time home buyers</strong> and for anyone that may sell or refinance before the loan term (commonly 30 years) because these options allow for more funds to be allocated to the down payment and these options also have less sunk costs associated with paying off the loan on sale of the property or refinancing the loan if interest rates drop.
                          Some of our products, such as the VA home loan for veterans, have <strong>zero down payment</strong> options for certain borrowers and conditions, such as borrowers with service-connected disabilities and appraisal value.
                          Another set of products, such as <a href="https://faq.capcenter.com/article/74-does-capcenter-offer-homeready-and-home-possible-products" target="_blank" rel="noreferrer noopener">HomeReady® and Home Possible</a>, have <strong>low down payment</strong> options for certain borrowers and conditions, such as first-time home buyers and income limits.
                          Our loan consultants can guide you through our loan products to find the best fit loan for your specific situation before and after you apply. We're dedicated to provide you fast and reliable services with our refined operational procedures. It'll feel like we're waiving closing costs, and the most frequently asked question after receiving a free quote is, "what's the catch?" That's our secret sauce, but we assure you that there is no catch and 95% of our past clients would recommend our services to friends and family.
                          In fact, we encourage you to shop around and compare loan estimates (it helps to compare rates, points, terms, mortgage insurance, lender closing costs, and non-lender closing costs as well) and any realty credits. Once we've gain your trust, we're here to help you purchase all your future homes, saving you time and money, over and over again.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm'}>Find our best REALTORS® near {props.custom.city}, {props.custom.state}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.city}, {props.custom.state}</a></p></>) : ""}
                          {props.custom.isMortgage ?
                            (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm'}>Apply now for a mortgage near {props.custom.city}, {props.custom.state}</a>) : ""}
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/virginia/glen-allen/purchase/all`)} className={'d-flex btn-primary btn-sm'}>View our best mortgage interest rates for today near {props.custom.city}, {props.custom.state}</a>
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm'}>Get a free, anonymous mortgage quote calculated to compare mortgage rates and closing costs in {props.custom.city}, {props.custom.state}</a>
                        </p>

                        <p>&nbsp;</p>
                      </div>

                      <div className="col-12 col-md-4 mb-4">
                        <img src={ImageGlenAllenOffice} alt={'CapCenter HQ 4461 Cox Rd, Glen Allen, VA 23060'} />
                      </div>

                      <div className="col-12 image-gallery">
                        <img src={ImageGlenAllenVA} alt={props.custom.title + " 4461 Cox Rd, Glen Allen, VA 23060 best realty office image"} />
                        <img src={ImageRichmondRaceway} alt={props.custom.title + " RVA Richmond Raceway best realty office image"} />
                        <img src={ImageGlenAllenVA2} alt={props.custom.title + " 4461 Cox Rd, Glen Allen, VA 23060 best realty office image"} />
                        <img src={ImageGlenAllenVAPieDay} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 1 best realty office image"} />
                        <img src={ImageGlenAllenVAPieDay2} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 2 best realty office image"} />
                        <img src={ImageGlenAllenVAPieDay3} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 3 best realty office image"} />
                        <img src={ImageGlenAllenVAPieDay4} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 4 best realty office image"} />
                        <img src={ImageGlenAllenVAHalloweenTeam} alt={props.custom.title + " RVA Richmond Glen Allen VA Halloween Winning Team best realty office image"} />
                        <img src={ImageGlenAllenVAHalloween} alt={props.custom.title + " RVA Richmond Glen Allen VA Halloween best realty office image"} />
                        <img src={ImageSmores} alt={props.custom.title + " RVA Richmond Glen Allen VA S'mores Day best realty office image"} />
                        <img src={ImageSmores2} alt={props.custom.title + " RVA Richmond Glen Allen VA S'mores Day best realty office image"} />
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <img src={ImageCapCenterHQ} alt={props.custom.title + " 4461 Cox Rd, Glen Allen, VA 23060 best realty office high quality image"} width={'500px'}/>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h4>Homes for Sale in {props.custom.city}, {props.custom.state}</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <ol>
                          {renderedHtmlListings}
                        </ol>
                      </div>
                    </div>
                  </section>


                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        {props.custom.isRealty ?
                          (<a href={getUrlWithUtmQueryString(`${baseUrl}/contact/best-mortgage-glen-allen-va`)}>Are you looking for the best home mortgage loan lender in Glen Allen, VA near Richmond VA (RVA)? CapCenter Mortgage offers Zero Closing Cost home loans in Glen Allen, VA since 1997 and a whopping 95% of our clients would recommend CapCenter to friends and family.</a>) : ""}
                        {props.custom.isMortgage ?
                          (<a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/contact/best-realty-glen-allen-va`)}>Are you looking for the best REALTORS® in Glen Allen, VA near Richmond, VA (RVA)? CapCenter Realty offers Zero Closing Cost home purchases and 1% Listing Fee bundle in Glen Allen, VA and a whopping 95% of our clients would recommend CapCenter to friends and family.</a>) : ""}
                      </div>
                    </div>
                  </section>

                </article>
              </main>
            </div>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default VAGlenAllen;
